import { useId } from "react";

interface WordmarkProps {
    width?: number | string;
    height?: number | string;
    viewBox?: string;
    [key: string]: any;
}

export const Wordmark = (props: WordmarkProps) => {
    const uid = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    const clipRootId = `${uid}-clip-root`;
    const clipMarkId = `${uid}-clip-mark`;
    const maskTriId = `${uid}-mask-tri`;
    const maskWedgeId = `${uid}-mask-wedge`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={569}
            height={100}
            viewBox="0 0 569 100"
            fill="none"
            {...props}
        >
            <g clipPath={`url(#${clipRootId})`}>
                <g clipPath={`url(#${clipMarkId})`}>
                    <mask
                        id={maskTriId}
                        width={130}
                        height={169}
                        x={149}
                        y={-15}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: "luminance",
                        }}
                    >
                        <path fill="#fff" d="M149 146h130V-15H149v161Z" />
                        <path
                            fill="#000"
                            d="m213.824 41.401 52.5 112h-105l52.5-112ZM174.324.094h80v-15h-80v15Z"
                        />
                    </mask>
                    <g mask={`url(#${maskTriId})`}>
                        <path fill="currentColor" d="m213.824-14.599 52.5 115h-105l52.5-115Z" />
                    </g>
                </g>
                <path
                    fill="currentColor"
                    d="M304.653 99.782c-8.12 0-14.887-1.073-20.3-3.22-5.413-2.24-9.567-5.273-12.46-9.1-2.8-3.827-4.387-8.167-4.76-13.02l24.36-.84c.56 3.36 1.913 5.88 4.06 7.56 2.147 1.68 5.227 2.52 9.24 2.52 3.267 0 5.787-.513 7.56-1.54 1.773-1.12 2.66-2.753 2.66-4.9 0-1.493-.373-2.707-1.12-3.64-.653-.933-2.007-1.773-4.06-2.52-1.96-.747-4.9-1.447-8.82-2.1-8.213-1.307-14.653-2.893-19.32-4.76-4.667-1.96-7.98-4.433-9.94-7.42-1.867-2.987-2.8-6.72-2.8-11.2 0-7.373 2.893-13.3 8.68-17.78 5.88-4.48 14.747-6.72 26.6-6.72 7.373 0 13.533 1.12 18.48 3.36 5.04 2.24 8.913 5.367 11.62 9.38 2.8 3.92 4.527 8.493 5.18 13.72l-23.94.84c-.28-2.333-.933-4.34-1.96-6.02-1.027-1.68-2.333-2.94-3.92-3.78-1.587-.933-3.5-1.4-5.74-1.4-3.173 0-5.693.7-7.56 2.1-1.773 1.307-2.66 3.127-2.66 5.46 0 1.587.373 2.94 1.12 4.06.84 1.027 2.193 1.867 4.06 2.52 1.867.653 4.387 1.213 7.56 1.68 8.12 1.027 14.607 2.567 19.46 4.62 4.853 1.96 8.353 4.527 10.5 7.7 2.24 3.08 3.36 6.86 3.36 11.34 0 4.947-1.447 9.147-4.34 12.6-2.8 3.453-6.813 6.067-12.04 7.84-5.227 1.773-11.48 2.66-18.76 2.66Zm82.901 0c-8.027 0-14.98-1.633-20.86-4.9-5.88-3.267-10.5-7.84-13.86-13.72-3.267-5.88-4.9-12.787-4.9-20.72 0-7.933 1.633-14.793 4.9-20.58 3.36-5.88 7.98-10.453 13.86-13.72 5.88-3.36 12.833-5.04 20.86-5.04 6.906 0 13.113 1.26 18.62 3.78 5.506 2.427 9.986 5.927 13.44 10.5 3.453 4.48 5.506 9.893 6.16 16.24l-24.64 1.12c-.654-4.573-2.194-7.98-4.62-10.22-2.427-2.333-5.414-3.5-8.96-3.5-4.76 0-8.447 1.867-11.06 5.6-2.52 3.733-3.78 9.007-3.78 15.82 0 6.907 1.26 12.227 3.78 15.96 2.613 3.733 6.3 5.6 11.06 5.6 3.64 0 6.673-1.167 9.1-3.5 2.52-2.333 4.013-5.973 4.48-10.92l24.64.84c-.56 6.44-2.52 12.04-5.88 16.8-3.36 4.667-7.794 8.26-13.3 10.78-5.507 2.52-11.854 3.78-19.04 3.78Zm48.925-1.68v-75.32h23.1l.84 22.82-1.82-.28c1.307-8.027 3.5-13.767 6.58-17.22 3.08-3.547 7.374-5.32 12.88-5.32h6.58v19.46h-6.72c-4.013 0-7.28.467-9.8 1.4-2.52.933-4.433 2.473-5.74 4.62-1.213 2.053-1.82 4.9-1.82 8.54v41.3h-24.08Zm80.249 1.68c-7.84 0-14.28-1.82-19.32-5.46-5.04-3.64-7.56-8.68-7.56-15.12 0-6.627 2.147-11.76 6.44-15.4 4.293-3.64 10.547-6.3 18.76-7.98l23.38-4.76c0-4.387-.98-7.7-2.94-9.94-1.867-2.333-4.573-3.5-8.12-3.5-3.547 0-6.347.887-8.4 2.66-1.96 1.68-3.22 4.107-3.78 7.28l-24.08-.84c1.493-8.68 5.367-15.12 11.62-19.32 6.253-4.2 14.467-6.3 24.64-6.3 11.76 0 20.533 2.66 26.32 7.98 5.88 5.32 8.82 13.253 8.82 23.8v23.8c0 2.333.373 3.873 1.12 4.62.84.747 1.96 1.12 3.36 1.12h1.82v15.68c-.747.28-1.96.513-3.64.7-1.68.187-3.313.28-4.9.28-2.893 0-5.693-.467-8.4-1.4-2.707-1.027-4.947-2.8-6.72-5.32-1.773-2.613-2.66-6.347-2.66-11.2l1.82 1.82c-.933 3.36-2.613 6.347-5.04 8.96-2.333 2.52-5.367 4.48-9.1 5.88-3.733 1.307-8.213 1.96-13.44 1.96Zm6.3-15.68c2.987 0 5.647-.607 7.98-1.82s4.153-2.987 5.46-5.32c1.307-2.333 1.96-5.227 1.96-8.68v-3.08l-14.56 3.36c-2.893.653-5.18 1.68-6.86 3.08-1.587 1.307-2.38 3.08-2.38 5.32s.7 4.013 2.1 5.32c1.4 1.213 3.5 1.82 6.3 1.82ZM99.295 40.684l34.208 59.25H65.087l34.208-59.25Z"
                />
                <mask
                    id={maskWedgeId}
                    width={116}
                    height={100}
                    x={5}
                    y={0}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: "alpha",
                    }}
                >
                    <path fill="#fff" d="M63.02.084h57.59v99.75H5.429L63.019.085Z" />
                </mask>
                <g mask={`url(#${maskWedgeId})`}>
                    <path fill="currentColor" d="M36.996 99.884-20.594.134h115.18l-57.59 99.75Z" />
                </g>
            </g>
            <defs>
                <clipPath id={clipRootId}>
                    <path d="M0 0h569v100H0z" />
                </clipPath>
                <clipPath id={clipMarkId}>
                    <path d="M279 146H149V-15h130z" />
                </clipPath>
            </defs>
        </svg>
    );
};